;(function (define) {
    'use strict'
    define( 'es6ish-class/lib/ES6ishClassError',['require','exports','module','./create'],function( require, exports, module ){
        var create = require( "./create" );

        var toString = Object.prototype.toString;

    	function ES6ishClassError( message, child, parent ){
    		this.name = 'ES6ishClassError';
    		Error.prototype.constructor.call( this, message );
    		this.message = message + ' : ' + toString.call( parent );
    		this.child = child;
    		this.parent = parent;
    	};
    	ES6ishClassError.prototype = create( Error.prototype );
    	return ES6ishClassError;
    });
})(typeof module === 'object' && module.exports && typeof define !== 'function'
    ? function (factory) { module.exports = factory(require, exports, module); }
    : define
);
